import {type BskyAgent} from '@atproto/api'

import {wsocFetch, xrpcPath} from '#/lib/wsoc/fetch'
import {type GetLinkedAccountsResponse} from './types'

export async function getLinkedAccounts(
  agent: BskyAgent,
  options?: {signal?: AbortSignal},
): Promise<GetLinkedAccountsResponse> {
  const accessJwt = agent.session?.accessJwt
  if (!accessJwt) {
    throw new Error('getLinkedAccounts: no active session')
  }
  return wsocFetch<GetLinkedAccountsResponse>(
    xrpcPath('eu.wsocial.quicklogin.getLinkedAccounts'),
    {body: {}, accessJwt, signal: options?.signal},
  )
}
